<span [ngClass]="{'no-rate-strike': showStrike===true}"
  >&nbsp;&nbsp;&nbsp;{{fwdPts}}&nbsp;&nbsp;&nbsp;</span
>
